export default __webpack_public_path__ + "static/media/Unaccessed.98fe0c87.svg";